<template>
	<div>
		<h1 v-if="!minimal">Traitements</h1>

		<b-form v-on:submit.prevent="onSubmit">
			<b-container fluid>
				<b-row>
					<b-col cols="4">
						<div>Projet</div>
						<v-select
							@input="onSubmit(true)"
							v-model="project"
							:options="projects_options"
							label="text"
							:reduce="(option) => option.value"
					/></b-col>
					<b-col v-if="canFilterByUser" cols="4">
						<div>Utilisateur</div>
						<v-select
							@input="onSubmit(true)"
							v-model="filterUser"
							:options="users_options"
							label="text"
							:reduce="(option) => option.value"
					/></b-col>
				</b-row>
			</b-container>
		</b-form>

		<br />

		<p>
			<b-button
				v-if="if_prev"
				v-on:click="
					page -= 1;
					onSubmit();
				"
				variant="primary"
				><i class="fas fa-arrow-circle-left"></i
			></b-button>
			Page {{ page + 1 }}
			<b-button
				v-if="if_next"
				v-on:click="
					page += 1;
					onSubmit();
				"
				variant="primary"
				><i class="fas fa-arrow-circle-right"></i
			></b-button>
		</p>

		<b-table
			striped
			hover
			:items="treats"
			:fields="fields"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			tbody-tr-class="rowClass">
			<template v-slot:cell(link)="data">
				<span v-if="!minimal">
					<router-link
						:to="{ name: 'treatment', params: { id: data.value } }"
						><i class="fas fa-external-link-alt"></i
					></router-link>
				</span>
				<span v-else>
					<b-button variant="link" @click="get_treatment(data.value)"><i class="fas fa-external-link-alt"></i></b-button>
				</span>
			</template>
			<template v-slot:cell(user)="data">
				{{ data.value ? data.value.prenom + " " + data.value.nom : "" }}
			</template>
		</b-table>
	</div>
</template>

<script>
	import treatments from "../services/treatments.js";
	import projects from "../services/projects.js";
	import store from "../store";

	export default {
		name: "ttreatments",
		data() {
			return {
				page: 0,
				sortBy: "date",
				sortDesc: true,
				project: null,
				filterUser: null,
				list_projects: [],
				projects_options: [],
				users_options: [],
				if_prev: true,
				if_next: true,
				fields: [
					{
						key: "libelle",
						label: "Nom",
						sortable: false,
					},
					{
						key: "date",
						label: "Date",
						sortable: false,
					},
					{
						key: "date_end",
						label: "Date de fin",
						sortable: false,
					},
					{
						key: "user",
						label: "Utilisateur",
						sortable: false,
					},
					{
						key: "link",
						label: "Lien",
					},
				],
				treats: [],
			requestId: 0,
			};
		},
		props: {
			minimal: {},
			default_project: {},
			size: {
				default: 30
			}
		},
		computed: {
			canFilterByUser() {
				const rules = store.state.user && store.state.user.rules;
				return !rules || !rules.treatment_view || rules.treatment_view === 'tout';
			}
		},
		methods: {
			get_project()
			{
				return this.project;
			},
			set_project(project)
			{
				this.project = project;

				this.onSubmit(true)
			},
			get_treatment(id)
			{
				console.log(id);
				this.$emit("treatment", id);
			},
			onSubmit: async function (reset = false) {
				if (reset) 
					this.page = 0;
				if (this.page < 0) 
					this.page = 0;
				if (!this.minimal)
				{
					this.$router
						.push({
							path: "treatments",
							query: { project: this.project, page: this.page },
						})
						.catch(() => {});
				}
				await this.getTreatments(this.project);
				if (this.page == 0) 
					this.if_prev = false;
				else this.if_prev = true;
				if (this.treats.length < this.size) 
					this.if_next = false;
				else 
					this.if_next = true;
			},
			changeProject: async function () {},
			getTreatments: async function (id_project) {
				try {
					this.treats = [];
					// Identifiant unique pour cette requête — si une nouvelle requête part avant
					// que celle-ci revienne, son id sera périmé et on ignorera la réponse.
					const requestId = ++this.requestId;
					var treats = await treatments.getAll(id_project, this.page, this.size, -1, this.filterUser);
					if (requestId !== this.requestId) {
						return;
					}
					var projects = treats["projects"];
					var users = {};
					for (var i = 0; i < treats["users"].length; i++) {
						users[treats["users"][i]["uid"]] = treats["users"][i];
					}
					if (this.canFilterByUser && this.users_options.length === 0) {
						this.users_options.push({ value: null, text: "Tous les utilisateurs" });
						var sorted_users = treats["users"]
							.filter(u => u.prenom || u.nom)
							.sort((a, b) => {
								var na = ((a.prenom || "") + " " + (a.nom || "")).trim().toLowerCase();
								var nb = ((b.prenom || "") + " " + (b.nom || "")).trim().toLowerCase();
								return na.localeCompare(nb);
							});
						for (var u of sorted_users) {
							this.users_options.push({ value: u.uid, text: ((u.prenom || "") + " " + (u.nom || "")).trim() });
						}
					}
					for (var i = 0; i < projects.length; i++) {
						if (projects[i]["traitements"]) {
							for (
								var j = 0;
								j < projects[i]["traitements"].length;
								j++
							) {
								var treat = {
									libelle: projects[i]["libelle"],
									date: projects[i]["traitements"][j][
										"dateheure_debut"
									],
									date_end:
										projects[i]["traitements"][j][
											"dateheure_fin"
										],
									link: projects[i]["traitements"][j]["uid"],
									user: users[
										projects[i]["traitements"][j][
											"client_user_uid"
										]
									],
								}
								
								if (projects[i]["traitements"][j].resultat == "ko")
            						treat._cellVariants = {
										libelle: 'danger',
										date: 'danger',
										date_end: 'danger',
										user: 'danger',
										link: 'danger'
									};

								this.treats.push(treat);
							}
						}
					}
				} catch (error) {
					console.log(error);
				}
			},
			getProjects: async function () {
				try {
					this.list_projects = await projects.getAll();
				} catch (error) {
					console.log(error);
				}
			},
		},
		created: async function () {
			if (store.state.user.rules && !store.state.user.rules.projects) {
				this.$router.push({ name: "profile" });
			}

			await this.getProjects();
			this.projects_options.push({ value: null, text: "Tous les projets" });
			for (var i = 0; i < this.list_projects.length; i++) {
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
			}

			if (this.default_project)
				this.project = this.default_project
			else if (this.$route.query.project)
				this.project = this.$route.query.project;
			else 
				this.project = null;

			if (this.$route.query.page)
				this.page = parseInt(this.$route.query.page);

			await this.getTreatments(this.project);

			if (this.page == 0) 
				this.if_prev = false;
			else 
				this.if_prev = true;
			if (this.treats.length < this.size) 
				this.if_next = false;
			else 
				this.if_next = true;
		},
	};
</script>

<style>
	.rowClass {
		background-color: pink;
	}
	.table-danger {
		background-color: pink !important;
	}
</style>
